<div class="container" fxLayout="column">
  <div class="favs" class="item">
    <div class="history" fxLayoutAlign="left center"><mat-icon>history</mat-icon>閲覧履歴</div>
    @if (artistHistory.length > 0) {
      <div>
        <mat-grid-list cols="3" rowHeight="5:3" gutterSize="6px" role="list">
          @for (history of artistHistory; track history) {
            <mat-grid-tile role="listitem">
              <div
                routerLink="../artists/{{ history.globalId }}/sales"
                class="fav historyTile"
                matRipple
                fxLayout
                fxLayoutAlign="center center"
                >
                <div>
                  {{ history.nameMain }}
                </div>
              </div>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </div>
    }
    @if (artistHistory.length == 0) {
      <div fxLayoutAlign="center center">
        閲覧履歴はありません
      </div>
    }
  </div>

  <mat-tab-group>
    @if (favorites$ | async; as favorites) {
      <div class="favs">
        <mat-tab label="邦楽">
          @if (hogakuItem) {
            <div class="favs">
              <div class="itemDiv">
                <mat-grid-list
                  cols="10"
                  gutterSize="15px"
                  role="list"
                  class="hogakuOrderGridList"
                  rowHeight="20px"
                  >
                  @for (orderItem of orderArr; track orderItem) {
                    <mat-grid-tile
                      role="listitem"
                      class="hogakuOrderTile"
                      >
                      <span
                        (click)="getArtistByalphabet($event)"
                        fxLayout
                        fxLayoutAlign="center center"
                        #orderTileDom1
                        class="orderItem1"
                        >{{ orderItem }}</span
                        >
                      </mat-grid-tile>
                    }
                  </mat-grid-list>
                </div>
                <mat-grid-list cols="3" rowHeight="5:3" gutterSize="6px">
                  @for (item of hogakuItem; track item) {
                    <mat-grid-tile>
                      <div
                        routerLink="../artists/{{ item.globalId }}/sales"
                        class="fav hogakuTile"
                        matRipple
                        fxLayoutAlign="center center"
                        >
                        <div fxLayout>
                          {{ item.nameMain }}
                        </div>
                      </div>
                    </mat-grid-tile>
                  }
                </mat-grid-list>
              </div>
            }
          </mat-tab>
          <mat-tab label="洋楽">
            @if (yogakuItem) {
              <div class="favs">
                <div class="itemDiv">
                  <mat-grid-list
                    cols="10"
                    gutterSize="15px"
                    role="list"
                    class="yogakuOrderGridList"
                    rowHeight="20px"
                    >
                    @for (orderItem of orderArr; track orderItem) {
                      <mat-grid-tile
                        role="listitem"
                        class="yogakuOrderTile"
                        >
                        <span
                          (click)="getArtistByalphabet($event)"
                          fxLayout
                          fxLayoutAlign="center center"
                          #orderTileDom2
                          class="orderItem2"
                          >{{ orderItem }}</span
                          >
                        </mat-grid-tile>
                      }
                    </mat-grid-list>
                  </div>
                  <mat-grid-list cols="3" rowHeight="5:3" gutterSize="6px" role="list">
                    @for (yogaku of yogakuItem; track yogaku) {
                      <mat-grid-tile role="listitem">
                        <div
                          routerLink="../artists/{{ yogaku.globalId }}/sales"
                          class="fav yogakuTile"
                          matRipple
                          fxLayoutAlign="center center"
                          >
                          <div fxLayout>
                            {{ yogaku.nameMain }}
                          </div>
                        </div>
                      </mat-grid-tile>
                    }
                  </mat-grid-list>
                </div>
              }
            </mat-tab>
            <mat-tab label="クラシック">
              @for (partition of favorites; track partition) {
                <div>
                  @if (partition[0] === 'クラシック') {
                    <mat-grid-list
                      cols="3"
                      rowHeight="5:3"
                      gutterSize="6px"
                      role="list"
                      >
                      @for (favorite of partition[1]; track favorite) {
                        <mat-grid-tile role="listitem">
                          <div
                            routerLink="../artists/{{ favorite.globalId }}/sales"
                            class="fav jazzTile"
                            matRipple
                            fxLayoutAlign="center center"
                            >
                            <div fxLayout>
                              {{ favorite.nameMain }}
                            </div>
                          </div>
                        </mat-grid-tile>
                      }
                    </mat-grid-list>
                  }
                </div>
              }
            </mat-tab>
            <mat-tab label="ジャズ">
              @for (partition of favorites; track partition) {
                <div>
                  @if (partition[0] === 'ジャズ') {
                    <mat-grid-list
                      cols="3"
                      rowHeight="5:3"
                      gutterSize="6px"
                      role="list"
                      >
                      @for (favorite of partition[1]; track favorite) {
                        <mat-grid-tile role="listitem">
                          <div
                            routerLink="../artists/{{ favorite.globalId }}/sales"
                            class="fav disneyTile"
                            matRipple
                            fxLayoutAlign="center center"
                            >
                            <div fxLayout>
                              {{ favorite.nameMain }}
                            </div>
                          </div>
                        </mat-grid-tile>
                      }
                    </mat-grid-list>
                  }
                </div>
              }
            </mat-tab>
            <mat-tab label="ディズニー">
              @for (partition of favorites; track partition) {
                <div>
                  @if (partition[0] === 'ディズニー') {
                    <mat-grid-list
                      cols="3"
                      rowHeight="5:3"
                      gutterSize="6px"
                      role="list"
                      >
                      @for (favorite of partition[1]; track favorite) {
                        <mat-grid-tile role="listitem">
                          <div
                            routerLink="../artists/{{ favorite.globalId }}/sales"
                            class="fav classicTile"
                            matRipple
                            fxLayoutAlign="center center"
                            >
                            <div fxLayout>
                              {{ favorite.nameMain }}
                            </div>
                          </div>
                        </mat-grid-tile>
                      }
                    </mat-grid-list>
                  }
                </div>
              }
            </mat-tab>
          </div>
        }
      </mat-tab-group>
    </div>
